<template>
  <div id="AppVersionsList">
    <div v-if="list">
      <v-container class="pa-0">
        <v-layout>
          <router-link to="/AppVersionAdd">
          <v-flex class="xs12 sm12 mb-5">
            <v-btn fab absolute right class="mr-3 pf-btn-fab">
              <v-icon>add</v-icon>
            </v-btn>
          </v-flex>
          </router-link>
        </v-layout>       
      </v-container>
      <v-container v-if="appVersionList.length == 0" class="text-center">
        <img src="static/NoBlogs.jpg" class="noItemsTemplate">
        <h4 class="pf-text-green"><b>No App Versions Found !! </b></h4>
    </v-container>
      <v-container v-else>
        <v-card class="mt-3">
          <v-data-table
            disable-initial-sort
            :headers="headers"
            :items="appVersionList"
            class="pf-data-table"
            ref="sortableTable"
            :pagination.sync="pagination" 
          >
            <template v-slot:items="props">
              <td>{{ props.item.android_version }}</td>
              <td>{{ props.item.ios_version }}</td>
              <td>{{ formatDateMethod(props.item.createdAt, 'MM/DD/YYYY') }}</td>
              <td align="right">
                <v-btn icon class="ma-0" @click="editItem(props.item)">
                  <v-icon size="22" color="grey darken-2">edit</v-icon>
                </v-btn>
              </td>
            </template>
          </v-data-table>
        </v-card>
      </v-container>
    </div>
    <div id="appVersionEdit" v-if="!list">
      <div id="appVersionEdit">
      <v-layout wrap row mb-1>
      <v-flex md6 pb-4 style="min-height:70px;">
        <v-btn fab left class="ml-3 pf-btn-fab" @click="backToList()">
          <v-icon>arrow_back</v-icon>
        </v-btn>
         </v-flex>
        <v-flex offset-md1 md5 v-if="selectedData">
        <div style="float:right">
          <v-btn class="pf-btn pf-btn-cancel" @click="backToList()">
            <v-icon size="16" class="pr-1">cancel</v-icon>
            <div>Cancel</div>
          </v-btn>
          <v-btn class="pf-btn pf-btn-save" @click="save">
            <v-icon size="16" class="pr-1">check_circle</v-icon>
            <div>Save</div>
          </v-btn>
        </div>
      </v-flex>
    </v-layout>
    <v-form ref="appVersionEdit">
      <v-container>
        <v-layout>
          <v-flex class="xs12 sm6 md7">
            <v-text-field label="Android Version" :rules="[rules.required, rules.versionFormat]" v-model.trim="editableAppVersion.android_version" class="required pr-4 pl-4" @input="changedData" required></v-text-field>
          </v-flex>
        </v-layout>
        <v-layout>
            <v-flex class="xs12 sm6 md7">
            <v-text-field label="IOS Version" :rules="[rules.required, rules.versionFormat]" v-model.trim="editableAppVersion.ios_version" class="required pr-4 pl-4" @input="changedData" required></v-text-field>
          </v-flex>
        </v-layout>
      </v-container>
    </v-form>
      <v-layout class="editor-button-container">
        <v-flex xs12 class="button-container text-xs-right" v-if="selectedData">
          <div class="d-inline-flex">
            <v-btn class="pf-btn pf-btn-cancel" @click="backToList()">
              <v-icon size="16" class="pr-1">cancel</v-icon>
              <div>Cancel</div>
            </v-btn>
            <v-btn class="pf-btn pf-btn-save" @click="save">
              <v-icon size="16" class="pr-1">check_circle</v-icon>
              <div>Save</div>
            </v-btn>
          </div>
        </v-flex>
      </v-layout>
  </div>
    </div>
  </div>
</template>
<script>
/* global session store config */
import swal from 'sweetalert2';
import { getCollection, update, formatDate } from '../../helpers/helpers';
import Vue from 'vue';
import { mapGetters } from 'vuex';

export default {
  data: () => ({
    editIndex: -1,
    list: true,
    headers: [
      { text: 'Android Version', value: 'android_version', align: 'left' },
      { text: 'IOS Version', value: 'ios_version', align: 'left' },
      { text: 'Date', value: 'createdAt', align: 'left' },
      { text: '', sortable: false },
    ],
    pagination: {
      sortBy: 'createdAt', // The field that you're sorting by
      descending: false,
      rowsPerPage: config.dom.rowsPerPage
    },
    selectedData: false,
    editableAppVersion: {},
    rules: {
      required: value => !!value || 'Version is required.',
      versionFormat: (v) => /(\d+\.)(\d+\.)(\d)/.test(v) || 'Please enter valid version'
    }    
  }),
  beforeRouteEnter (to, from, next) {
    if (!session.isOnline()) {
      next({ path: '/login' });
    } else {
      next();
    }
  },
  computed: {
    appVersionList: {
      get () {
        return store.state.appVersionList;
      },
      set (value) {
        store.commit('setAppVersionList', value);
      }
    },
  },
  created () {
    this.getAppVersionList();
  },
  methods: {
    formatDateMethod (date, format = 'MM/DD/YYYY') {
      return formatDate(date, format);
    },
    async getAppVersionList () {
      if (!this.appVersionList.length) {
        let entity = `AppVersion`;
        let { error, data } = await getCollection(entity, true);
        if (error) {
          console.log(error);
        } else {
          if (data.length > 0) {
            this.appVersionList = data;
          }
        }
      }
    },
    changedData () {
      this.selectedData = true;
    },
    editItem (item) {
      this.editIndex = this.appVersionList.indexOf(item);
      window.getApp.$emit('pageSubHeader', 'Edit');
      this.list = false;
      this.editableAppVersion = { ...item };
    },
    backToList () {
      window.getApp.$emit('pageSubHeader', '');
      this.list = true;
      this.editIndex = -1;

    },
    async save () {
      if (this.$refs.appVersionEdit.validate()) {
        this.selectedData = false;
        let payload = {
          'ios_version': this.editableAppVersion.ios_version,
          'android_version': this.editableAppVersion.android_version
        };
        let { error, data } = await update('AppVersion', payload, this.editableAppVersion.id);
        if (error) {
          this.selectedData = true;
          console.log('error', error);
        } else {
          this.appVersionList[this.editIndex] = data;
          swal.fire({
            type: 'success',
            title: 'App Version updated successfully',
            showConfirmButton: false,
            timer: 2500,
            onClose: () => {
              this.editIndex = -1;
              this.list = true;
              window.getApp.$emit('pageSubHeader', '');
            }
          });
        }
      }
    },
  }
};
</script>



// WEBPACK FOOTER //
// src/pages/AppVersion/list.vue